export default "__VITE_ASSET__Bp3rNz8B__"